import { isPrivateAdvertiser } from "./typeguards.ts";

export enum EventType {
  View = "View",
  Click = "Click",
  UIElement = "UIElement",
  ClassifiedAd = "ClassifiedAd",
}

export enum ObjectPosition {
  Map = "Map",
  AboveMap = "Above map",
  BelowGallery = "Below gallery",
}

export enum ElementType {
  Button = "Button",
  Link = "Link",
  Map = "Map",
  Tab = "Tab",
  Image = "Image",
  EmailIcon = "Email icon",
  CopyLink = "Copy link",
  FacebookIcon = "Facebook icon",
  PhoneNumber = "Phone number",
  TwitterIcon = "Twitter icon",
  Video = "Video",
}

export enum Intent {
  Call = "Call",
  Cancel = "Cancel",
  Click = "Click",
  Create = "Create",
  Dismiss = "Dismiss",
  Edit = "Edit",
  Like = "Like",
  Login = "Login",
  Minimize = "Minimize",
  Open = "Open",
  Report = "Report",
  Send = "Send",
  Share = "Share",
  Show = "Show",
  Sort = "Sort",
  Unlike = "Unlike",
  View = "View",
  Watch = "Watch",
}

export enum TargetType {
  Article = "Article",
  ClassifiedAd = "ClassifiedAd",
  ExternalContent = "ExternalContent",
  Form = "Form",
  Listing = "Listing",
  Page = "Page",
  Message = "Message",
}

export const getListingType = (ownerUrn: string): string => {
  const isPrivateAd = isPrivateAdvertiser(ownerUrn);
  return isPrivateAd ? "private" : "professional";
};
